module.exports = __webpack_public_path__ + "img/imagen3.dd5a5248.png";